var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRomaingMassLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.663 5.224c-.146.132-.634.58-.764.713l-2.728 2.598c-.03.027-.072.042-.108.027L7.205 6.074a.933.933 0 0 0-.87.206l-1.02.922c-.241.218-.105.533.183.68l7.713 4.2a.114.114 0 0 1 .027.186l-5.2 4.839a.467.467 0 0 1-.405.123l-3.344-.498a.92.92 0 0 0-.78.227l-.723.654c-.12.109-.098.3.042.376l3.53 2.184c.212.105.38.29.463.513l1.816 3.732c.062.147.249.19.37.08l.718-.65a.939.939 0 0 0 .306-.752l-.155-3.435a.475.475 0 0 1 .164-.39l5.346-4.618c.064-.05.153-.03.182.046l3.402 8.103c.116.301.416.469.657.25l1.02-.921a.925.925 0 0 0 .294-.844l-1.47-10.06a.114.114 0 0 1 .038-.104l2.86-2.452c.15-.12.641-.555.788-.687 1.907-1.723 2.557-3.428 1.868-4.19-.688-.763-2.45-.297-4.362 1.43z",
    fill: "#DCF4E8",
    stroke: "url(#k5kaaufzsa)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k5kaaufzsa",
    x1: 25.598,
    y1: -0.709,
    x2: 7.244,
    y2: 0.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomaingMassLight);
export default __webpack_public_path__ + "static/media/Romaing_Mass_Light.827b5cab9acb19effb968efc1a09c378.svg";
export { ForwardRef as ReactComponent };